import { nortadaLogger } from '../../../../../common/logger';

import { APP_CREATION_PERMISSION_STATUS } from './interfaces';

export const getPermissionToCreateApps = (permissionStatus: APP_CREATION_PERMISSION_STATUS): boolean => {
  switch (permissionStatus) {
    case 'ALLOWED':
      return true;
    case 'CREATED_APPS_LIMIT_REACHED':
      return false;
    default:
      nortadaLogger.critical(`${permissionStatus} is not a valid app create permission status.`);
      return false;
  }
};
